import React from 'react';

import {Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {SearchBarUnitProps} from '../SearchBarUnit/types';
import {useCurrentLocation} from './hooks/useCurrentLocation';
import {StyledButton} from './styles';

const {yourCurrentLocation, locationSelected, change} = translations['pt-br'].commons;

export function CurrentLocation({type}: SearchBarUnitProps) {
	const {palette, coordinates, cdUf, cityName, handleGoToUfSelection} = useCurrentLocation(type);

	return (
		<Stack direction="row" justifyContent={'space-between'} gap={1.5}>
			<Stack direction="row" gap={1} alignItems={'center'}>
				<Icon name="location-on-filled" size={24} color={palette.primary.main} />
				<Stack>
					<Typography variant="caption" color="text.secondary">
						{coordinates?.lat && coordinates?.lng
							? yourCurrentLocation
							: locationSelected}
					</Typography>
					<Typography variant="subtitle2" color="primary" fontWeight={600}>
						{formatText(cityName)}/{cdUf}
					</Typography>
				</Stack>
			</Stack>
			<StyledButton variant="text" onClick={handleGoToUfSelection}>
				{change}
			</StyledButton>
		</Stack>
	);
}
